import { memo } from 'react'
import { InputWithIcon } from 'components/ui/selects/InputWithIcon'
import { ISelectInputProps } from 'components/ui/selects/SelectInputTypes'
import { TCustomer } from 'modules/customer/types'

export const SelectCompanyInput = memo(function SelectCompanyInput({
  searchValue,
  onChange,
  desktopParentElement
}: ISelectInputProps<TCustomer>) {
  return (
    <>
      <InputWithIcon
        desktopParentElement={desktopParentElement}
        onChange={onChange}
        placeholder=""
        testId="customers-page--add-new-customer-form--company-name-input"
        value={searchValue}
      />
    </>
  )
})
